<template>
    <transition name="modal">
      <div class="modal-mask">
        <div class="modal-wrapper">
          <div class="modal-container">
            <!-- TITULO -->
            <b-row>
              <b-col>
                <h4>
                  Transferencia
                </h4>
              </b-col>
            </b-row>
            <!-- CABECERA TOTALES -->
            <b-row class="modal-header">
              <b-col cols="md-12">
              <slot name="header">
                <div v-if="limited">
                  <b-row v-if="( (header.pos!=0) && (total>=500000) && ( (header.letter=='C') || (header.letter=='B')) )">
                    <div class="col-md-12 text-center">
                      <div class="alert alert-danger" role="alert">
                        <h4>
                          ¡Record&aacute; que para realizar una factura mayor a $ 500.000 ten&eacute;s que informar a la AFIP todos los datos del cliente!
                        </h4>
                      </div>
                    </div>
                  </b-row>
                </div>
                <b-row>
                  <b-col cols="md-6 text-left">
                    <h3 class="font-weight-bolder">
                      Total: $ {{ round(total,2) }}
                    </h3>
                  </b-col>
                </b-row>
                
                <b-row>
                  <b-col cols="md-6 text-left">
                    <ul class="list-unstyled">
                      <li><h5>Transferencia: ${{ totalTransfer }}</h5></li>
                    </ul>
                  </b-col>
                </b-row>
                <b-col cols="md-3 text-left">
                <b-row>
                    <div v-if="limited">
                      <h5 v-if="diference!=0">Diferencia: $ {{ round(diference,2) }}</h5>
                    </div>
                  </b-row>
                </b-col>
              </slot>
              </b-col>
            </b-row>
            <b-row class="my-3 bg-light p-4 border rounded">
              <b-col cols="md-6" class="mb-3">
                <b-form-group class="col-border">
                  <label>Tranferencia</label>
                  <input v-model.number="transfer" type="number" min="0" step="0.01" class="form-control form-control-lg" @input="updateBanks">
                </b-form-group>
              </b-col>
              <b-col cols="md-6" class="mb-3">
                <b-form-group>
                  <label>Caja banco destino</label>
                  <div class="d-flex align-items-center">
                    <select v-model="fundTransfer" class="form-control form-control-lg" name="fund_id" @change="updateBanks">
                      <option disabled value="0" selected>Seleccione una caja...</option>
                      <option v-for="fundBank in fundsBank" :key='fundBank.id' :value="fundBank.id">{{fundBank.name}}</option>
                    </select>
                    <b-button @click="addInputSelect" class="ml-4">Agregar</b-button>
                  </div>
                </b-form-group>
              </b-col>
              <b-col cols="md-6">
                <div v-for="(inputSelect, index) in inputSelects" :key="index" class="mt-4">
                  <b-form-group>
                    <input v-model.number="inputSelect.input" type="number" min="0" step="0.01" class="form-control form-control-lg" placeholder="0" @input="updateBanks">
                  </b-form-group>
                </div>
              </b-col>
              <b-col cols="md-6">
                <div v-for="(inputSelect, index) in inputSelects" :key="index" class="mt-4" style="width: 94%;">
                  <b-form-group>
                    <select v-model="inputSelect.select" class="form-control form-control-lg" name="fund_id" @change="updateBanks">
                      <option v-for="fundBank in fundsBank" :key='fundBank.id' :value="fundBank.id">{{fundBank.name}}</option>
                    </select>
                  </b-form-group>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col class="d-flex justify-content-end">
                <b-button 
                v-if='limited' 
                class="p-3" 
                variant="outline-primary" 
                size="lg" 
                @click="modified">
                  Cancelar
                </b-button>
                <b-button 
                class="p-3 ml-4" 
                variant="orange" 
                size="lg" 
                :disabled="!(round(diference,2)==0) || (limited==0)" @click="finishReceipt">
                Finalizar venta
                </b-button>
              </b-col>
            </b-row>
          </div>
        </div>
      </div>
    </transition>
  
</template>
  
<script>

export default {
  props: ['total', 'paymentMethods', 'header', 'limited', 'fundDefault', 'genType'],
  data: function() {
    return {
      totalpayed: 0,
      diference: 0,
      fundsBank: [],
      payarray: {
        banks:[],
        cash: 0,
        fund_id: 0,
        fundBanks_id: [],
        accounts: [],
        creditcards: [],
        tpchecks: []
      },
      inputSelects: [],
      transfer: 0,
      fundTransfer: 0,
      totalTransfer: 0,
    }
  },
  mounted: function () {
    this.payarray.fund_id = this.fundDefault;
    this.transfer = this.total;
    
    this.getFunds();
    this.calc();
  },
  computed: {
      banks: {
          get: function () {
              return this.payarray.banks;
          },
          set: function (value) {
              if (value==''){
                  this.transfer = 0;
              }else{
                  this.transfer = value;
              }
          }
      },
  },
  watch: {
    payarray: {
      handler: function () {
        this.calc();
      }, deep: true
    }
  },
  methods: {
    round: function(value, decimals) {
      return (Number(Math.round(value + 'e' + decimals) + 'e-' + decimals));
    },
    updateBanks() {
      const banks = [{ amount: this.transfer }];
      const fundTransfer = [{fund: this.fundTransfer}];
      const inputSelectsBanks = this.inputSelects.map(select => ({
        amount: select.input,
      }));

      const selectSelectsBanks = this.inputSelects.map(select => ({
        fund: select.select,
      }));
      this.payarray.fundBanks_id = fundTransfer.concat(selectSelectsBanks);
      this.payarray.banks = banks.concat(inputSelectsBanks);
      console.log(this.payarray.fundBanks_id);
      this.calcTotalTransfer();
    },

    addInputSelect() {
      this.inputSelects.push({ input: 0, select: '' });
      console.log(this.inputSelects.length);
    },
    calcTotalTransfer() {
      this.totalTransfer = this.payarray.banks.reduce((sum, bank) => sum + bank.amount, 0);
    },
    calc: function () {
      this.totalpayed = 0;
      
      if(this.payarray.cash==''){
        this.payarray.cash = 0;
      }

      var totalbanks = this.totalTransfer;      

      this.totalpayed = this.round(totalbanks,2);
      this.diference = this.round(this.total,2) - this.round(this.totalpayed,2);
    },
  
    fromdateUpdated: function (date) {
      this.header.service_fromdate = date;
    },
    modified: function () {
      this.$emit('paymentmethodschanged',{});
      this.$emit('close');
    },
    finishReceipt: function () {
      this.$emit('paymentmethodsclose',this.payarray);
      this.$emit('close');
    },
    getFunds() {
      var vm = this;
      window.axios.get('/api/funds/list')
      .then(response => {
        if(response.data) {
          vm.fundsBank = response.data.data.filter(fund => fund.type === 'Banco');
        }
      })
      .catch(error => {
        alert(error);
      })
    }
  },
}
</script>

<style scoped>

.modal-mask {
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 60%;
  height: auto;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin: 0; /* Asegúrate de no tener margen automático aquí */
  padding: 40px;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  overflow-y: auto;
}
@media (max-width: 600px) {
  .modal-container {
      width: 98%;
      height: auto;
      padding: 15px; /* Espaciado reducido para móviles */
      border-radius: 4px; /* Puede omitir el borde redondeado si ocupa toda la pantalla */
  }
}


.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>